import React, { useEffect, useRef, useState } from 'react';
import { ChartOptions, ChartData, Chart } from 'chart.js';
import { Chart as ChartJS } from 'react-chartjs-2';
import { Modal, Button, Form } from 'react-bootstrap';

import { FiltroSopSales, RepositorioSopSales } from '../../core/repositories/sopSalesRepositorio';
import { formatarDecimal, formatarPorcentagem, formatLargeNumber } from '../../core/utils/funcoes';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import { useAutenticação } from '../../core/contexts/auth';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
interface Props {
    filtro: FiltroSopSales;
    home: boolean;
    onChange?: (mes: string, valor: number) => void;
}

export const SopFinanceSalesForecastChart: React.FC<Props> = (props) => {
    const chartRef = useRef<Chart<'bar'>>(null);
    const { mostrarToast } = useToast();
    const { t } = useTranslation();

    const [data, setData] = useState<ChartData<"bar" | "line">>({} as ChartData<"bar" | "line">);
    const [carregando, setCarregando] = useState(true);
    const { usuario } = useAutenticação()

    const [showCarregando, setShowCarregando] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [novoValor, setNovoValor] = useState<string>('');
    const [modalInfo, setModalInfo] = useState<{ label: string, index: number, currentValue: number | null, currentValueDestaque: number | null } | null>(null);

    useEffect(() => {
        if (usuario && usuario.cod_usuario) {
            setCarregando(true);
            props.filtro.cod_usuario = usuario.cod_usuario;
            new RepositorioSopSales().getPrevisao(props.filtro).then((res) => {
                const labels: string[] = [];
                const real: (number | null)[] = [];
                const forecast: (number | null)[] = [];
                const budget: (number | null)[] = [];
                const avg_price: (number | null)[] = [];

                res.forEach((item: any) => {
                    const mes = item.mes || "";
                    const valorReal = item.real ?? null;
                    const destaque = mes === "May/2025" ? 6 : 0;

                    labels.push(mes);
                    real.push(valorReal !== null ? valorReal - destaque : null);
                    forecast.push(item.hasOwnProperty('forecast') ? item.forecast : null);

                    budget.push(item.hasOwnProperty('budget') ? item.budget : null);
                    avg_price.push(item.hasOwnProperty('avg_price') ? item.avg_price : null);
                });
                
                setData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Actual',
                            data: real,
                            backgroundColor: '#1e88e5',
                            stack: 'stack1',
                        },
                       
                        {
                            label: 'Forecast',
                            data: forecast,
                            backgroundColor: '#90CAF9',
                            borderColor: '#90CAF9',
                            stack: 'stack2',
                        },
                        {
                            label: 'Budget',
                            type: 'line',
                            data: budget,
                            borderColor: '#9e9e9e',
                            backgroundColor: '#9e9e9e',
                            pointRadius: 0,
                            fill: false,
                            yAxisID: 'y',
                        },
                        {
                            hidden: props.filtro?.value == "Quantity",
                            label: 'Average Price',
                            type: 'line',
                            data: avg_price,
                            borderColor: '#f9a825',
                            backgroundColor: '#f9a825',
                            pointRadius: 3,
                            fill: false,
                            tension: 0.4,
                            yAxisID: 'y2',
                            segment: {
                                borderDash: ctx => ctx.p0DataIndex >= 3 ? [6, 6] : undefined,
                            },
                        },
                    ],
                });

                setCarregando(false);
            }).catch((error) => {
                mostrarToast({
                    titulo: t("pages.Erro!"),
                    mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                    tipo: "error",
                });
            })
        }

    }, [props.filtro, usuario]);

    useEffect(() => {
        console.log("usuario", usuario);
        if (usuario && usuario.cod_usuario) {
        }
    }, [usuario]);


    const options: ChartOptions<"bar" | "line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    filter: function (item) {
                        return item.text !== 'Forecast - Edit' && !(props.filtro?.value == "Quantity" && item.text == "Average Price"); // 🔥 oculta só esta legenda
                    }
                }
            },
            title: {
                display: false,
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                // filter: function (tooltipItem) {
                //     const value = tooltipItem.raw;
                //     if (tooltipItem.dataset.label === 'Forecast - Edit') {
                //         const datasetIndex = tooltipItem.datasetIndex - 1;
                //         const dataset = tooltipItem.chart.data.datasets[datasetIndex];
                //         const forecastValue = dataset.data[tooltipItem.dataIndex];
                //         return value !== forecastValue;
                //     }
                //     return value !== null && value !== undefined && value !== '-';
                // },
                callbacks: {
                    label: function (context: any) {
                        const value = context.parsed.y;
                        return `${context.dataset.label}: ${formatarDecimal(value, props.filtro?.value !== "Quantity").replace("R$", props.filtro?.value !== "Quantity" ? "$" : "")}`;
                    },
                },
            },
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                beginAtZero: false,
                ticks: {
                    callback: (value: any) => formatLargeNumber(value, props.filtro?.value !== "Quantity" ? "$" : ""),
                },
            },
            y2: {
                display: props.filtro?.value != "Quantity",
                type: 'linear',
                position: 'right',
                beginAtZero: false,
                ticks: {
                    callback: (value: any) => formatLargeNumber(value, props.filtro?.value !== "Quantity" ? "$" : ""),
                },
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
        onClick: (evt, elements) => {
            if (!elements.length) return;
            const chart = chartRef.current;
            if (!chart) return;
            const element = elements[0];
            const datasetIndex = element.datasetIndex;
            const index = element.index;
            const dataset = chart.data.datasets[datasetIndex];
            const label = dataset.label;
            const currentValue = dataset.data[index] as number | null;
            // Pegar o valor do dataset "Forecast - Edit"
            const datasetDestaque = chart.data.datasets.find(d => d.label === 'Forecast - Edit');
            if (!datasetDestaque) return;
            const currentValueDestaque = datasetDestaque.data[index] as number | null;

            if (label === 'Forecast') {
                setModalInfo({ label, index, currentValue, currentValueDestaque });
                setNovoValor('');
                setShowModal(true);
            }
        }
    };

    // const salvarValor = () => {
    //     if (!modalInfo || !data || !data.datasets) return;

    //     var mes = (data.labels?.[modalInfo?.index ?? 0] ?? '').toString();
    //     const { label, index } = modalInfo;
    //     const novo = parseFloat(novoValor);
    //     if (isNaN(novo)) return;
    //     const dataset = data.datasets.find(d => d.label === "Forecast - Edit");
    //     if (!dataset) return;

    //     setShowModal(false);
    //     setShowCarregando(true);

    //     const currentValue = dataset.data[index] as number | 0;
    //     const diff = ((novo - currentValue) / currentValue);

    //     dataset.data[index] = novo;
    //     setData({ ...data });
    //     chartRef.current?.update();

    //     props.onChange?.(mes, diff);
    //     setTimeout(() => {
    //         setShowCarregando(false);
    //     }, 1500);




    //     const _centro = new RepositorioSopSales();
    //     var filtroAux = { ...props.filtro }
    //     filtroAux.cod_usuario = usuario?.cod_usuario;
    //     // filtroAux.des = mes;
    //     filtroAux.des_valor = novo
    //     setShowCarregando(true)
    //     _centro.postSimular(filtroAux).then((atualizadas) => {
    //         if (atualizadas) {
    //             const currentValue = dataset.data[index] as number | 0;
    //             const diff = ((novo - currentValue) / currentValue);

    //             dataset.data[index] = novo;
    //             setData({ ...data });
    //             chartRef.current?.update();
    //         }
    //         setShowCarregando(false)
    //         mostrarToast({
    //             titulo: "Sucesso",
    //             mensagem: `Linha(s) atualizada(s)`,
    //             tipo: "success",
    //         });
    //     }).catch(err => {
    //         setShowCarregando(false)
    //         mostrarToast({
    //             titulo: "Erro",
    //             mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
    //             tipo: "error",
    //         });
    //     });
    // };
    function CalcPercent(item1?: any, item2?: any) {
        if (item1 && item2) {
            item1 = Number.parseFloat(item1);
            item2 = Number.parseFloat(item2);
            return (item1 - item2) / item2;
        } else {
            return 0;
        }
    }

    function varicaoPreco(preco1?: number, preco2?: number) {
        if (!preco1 || !preco2) {
            return "-"
        }
        var a = CalcPercent(preco1, preco2)
        if (a > 0) {
            return <>
                <span style={{ color: "green" }}>{formatarPorcentagem(a)}</span>
                <FaArrowUp color="green" />
            </>
                ;
        } else if (a < 0) {
            return <>
                <span style={{ color: "red" }}>{formatarPorcentagem(a)}</span>
                <FaArrowDown color="red" />
            </>
        } else {
            return <span>{formatarPorcentagem(a)}</span>;
        }
    }


    return (
        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">Sales{!props.home ? " Forecast vs Real & Budget" : ""}</strong>
            {carregando ?
                <SopLoadingAnimation type="CHARTS" />
                :
                <ChartJS ref={chartRef} type='bar' options={options} data={data}  />
            }

            {/* <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Forecast Value ({(data.labels?.[modalInfo?.index ?? 0] ?? '').toString()})</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mt-0 pt-0'>
                    <Form.Group>
                        <Form.Label>
                            Value IA: {modalInfo?.currentValue !== null ? formatarDecimal(modalInfo?.currentValue, props.filtro?.value !== "Quantity").replace("R$", "$") : 'N/A'} <br />
                            Value Edit: {modalInfo?.currentValue !== null ? formatarDecimal(modalInfo?.currentValueDestaque, props.filtro?.value !== "Quantity").replace("R$", "$") : 'N/A'} <br />
                            Δ {modalInfo?.currentValue !== null ? formatarDecimal(modalInfo?.currentValueDestaque! - modalInfo?.currentValue!, props.filtro?.value !== "Quantity").replace("R$", "$") : 'N/A'}
                            | {varicaoPreco(modalInfo?.currentValueDestaque || 0, modalInfo?.currentValue || 0)}
                        </Form.Label>
                        <Form.Control
                            type="number"
                            value={novoValor}
                            onChange={(e) => setNovoValor(e.target.value)}
                            placeholder="New value"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={salvarValor}>Save</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showCarregando} onHide={() => setShowCarregando(false)} centered className='modal-transparent'>
                <Modal.Body className='border-0'>
                    <SopLoadingAnimation type="IA" />
                </Modal.Body>
            </Modal> */}
        </div>
    );
};
